import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { SuratJalanBateraiRestService } from '../surat-jalan-baterai-rest.service';
import Swal from 'sweetalert2';
import { SuratJalanBateraiListComponent } from '../list/surat-jalan-baterai-list.component';
import * as moment from 'moment';
import 'moment/locale/id'; // ini penting buat Bahasa Indonesia
import { AddModalComponent } from '../add-modal/add-modal.component';
import { DraftModalComponent } from '../draft-modal/draft-modal.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-detail-modal',
  templateUrl: 'detail-modal.component.html',
  styleUrls: ['../surat-jalan-baterai-module.scss']
})
export class DetailModalComponent {
  @ViewChild('addModal') addModal: AddModalComponent;
  @ViewChild('draftModal') draftModal: DraftModalComponent;
  @Input() suratJalanBaterai: any;
  @Input() edit: boolean = false;
  isModalOpen: boolean = false;
  photoPreviewModal: boolean = false;
  photoPreviewTitle: string = '';
  // In your component.ts
  openedIndex: number | null = null;
  value = JSON.parse(localStorage.getItem('ngx-webstorage|currentuser') || '{}');
  sjbDetail: any;
  isSjbDetailLoading: boolean = false;
  rejectAction: boolean = false;
  rejectReason: string = '';
  selectedTab: string = 'tiket';
  finalLocation: string = '';
  finalAddress: string = '';
  isRequestOpenDoor: boolean = false; // New property to track open door request
  customer: any;

  toggleAccordion(index: number): void {
    this.openedIndex = this.openedIndex === index ? null : index;
  }

  constructor(
    private _SuratJalanBateraiRest: SuratJalanBateraiRestService,

    public _suratJalanBateraiListComponent: SuratJalanBateraiListComponent,

    private el: ElementRef
  ) {}

  formattedDate(date: string): string {
    return moment(date).format('D MMMM YYYY');
  }

  async getPresignedUrl(suratJalanBaterai) {
    for (const surat of suratJalanBaterai) {
      if (surat.shippingInformation?.shippingProof) {
        const filePayload = { storageFileName: surat.shippingInformation?.shippingProof };
        this._SuratJalanBateraiRest.getPresignedUrl(filePayload).subscribe({
          next: response => {
            // Update the original object properties directly
            if (surat.shippingInformation) {
              surat.shippingInformation.shippingProofUrl = response.url;
            }
            // No need to return anything
          },
          error: err => {
            console.error('Error getting presigned URL:', err);
          }
        });
      }
    }
  }

  openModal() {
    this.isModalOpen = true;
    // Get sjb detail
    this.getSjbDetail();
  }

  closeModal() {
    this.isModalOpen = false;
    this.rejectReason = '';
  }

  showRejectAction() {
    this.rejectAction = !this.rejectAction;
  }

  closePhotoPreviewModal() {
    this.photoPreviewModal = false;
  }

  setTab(tab: 'tiket' | 'pelanggan') {
    this.selectedTab = tab;
  }

  async openPhotoPreview(file, title) {
    this.photoPreviewModal = true;
    this.photoPreviewTitle = title;

    setTimeout(() => {
      const photoPreview = this.el.nativeElement.querySelector('#js-photoPreview');
      if (photoPreview) {
        photoPreview.src = file;
        photoPreview.href = file;
      } else {
        console.error('photoPreview element not found');
      }
    }, 0); // Wait for the DOM update
  }

  getSjbDetail() {
    this.isSjbDetailLoading = true;

    this._SuratJalanBateraiRest.getDetail(this.suratJalanBaterai._id).subscribe({
      next: (response: any) => {
        this.sjbDetail = response;
        this.finalLocation = this.sjbDetail[0].startingLocation;
        this.finalAddress = this.sjbDetail[0].startingAddress;
        this.customer = this.sjbDetail[0].customer;
        this.isRequestOpenDoor = this.sjbDetail[0].suratJalanType === 'permintaan_buka_pintu';
        // Fetch presigned URLs for shipping proofs
        this.getPresignedUrl(this.sjbDetail);
        this.isSjbDetailLoading = false;
      },
      error: err => {
        this.isSjbDetailLoading = false;
      }
    });
  }

  downloadBatteryCodes(codes) {
    try {
      // Buat data untuk Excel, dengan header "Kode Baterai"
      const data = codes.map(code => ({ 'Kode Baterai': code }));

      // Buat worksheet dari data
      const ws = XLSX.utils.json_to_sheet(data);

      // Buat workbook dan masukkan worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Baterai');

      // Generate file Excel dan download
      XLSX.writeFile(wb, 'BatteryCodes.xlsx');

      // Tampilkan pesan sukses
      Swal.fire('Success', 'Download data baterai sukses!', 'success');
    } catch (error) {
      console.error('Error downloading Excel file:', error);
      Swal.fire('Error', 'Terjadi kesalahan saat mendownload file Excel.', 'error');
    }
  }
  onReject(id, reason) {
    // Add confirmation before rejecting
    if (!reason) {
      Swal.fire('Error', 'Alasan reject tidak boleh kosong.', 'error');
      return;
    }

    Swal.fire({
      title: 'Konfirmasi',
      text: 'Apakah kamu yakin ingin reject surat jalan ini?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Ya, Reject',
      cancelButtonText: 'Batal',
      confirmButtonColor: '#d33'
    }).then(result => {
      if (result.isConfirmed) {
        this._SuratJalanBateraiRest.reject(id, reason).subscribe({
          next: response => {
            Swal.fire('Success', 'Reject success!', 'success');
            this._suratJalanBateraiListComponent.callHookDirectly('init');
            this.closeModal(); // Close modal on success
          },
          error: err => {
            const errorMessage = err.response?.data?.message || 'Unknown error occurred';
            Swal.fire('Error', `Failed to reject: ${errorMessage}`, 'error');
          }
        });
      }
    });
  }

  formatSuratJalanType(type: string): string {
    switch (type) {
      case 'return':
        return 'Return';
      case 'permintaan_buka_pintu':
        return 'Permintaan Buka Pintu';
      case 'permintaan':
        return 'Permintaan';
      case 'pengiriman':
        return 'Pengiriman';
      default:
        return type.replace(/_/g, ' ');
    }
  }

  onApprove(id) {
    // Add confirmation before approving
    Swal.fire({
      title: 'Konfirmasi',
      text: 'Apakah kamu yakin ingin approve surat jalan ini?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Ya, Approve',
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Batal'
    }).then(result => {
      if (result.isConfirmed) {
        this._SuratJalanBateraiRest.approve(id).subscribe({
          next: response => {
            Swal.fire('Success', 'Approve success!', 'success');
            this._suratJalanBateraiListComponent.callHookDirectly('init');
            this.closeModal(); // Close modal on success
          },
          error: err => {
            const errorMessage = err.response?.data?.message || 'Unknown error occurred';
            Swal.fire('Error', `Failed to approve: ${errorMessage}`, 'error');
          }
        });
      }
    });
  }

  onDeliver(id) {
    // Add confirmation before marking as delivered
    Swal.fire({
      title: 'Konfirmasi Pengiriman',
      text: 'Apakah kamu yakin barang sudah diterima?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Ya, Sudah Diterima',
      confirmButtonColor: '#28a745', // Green color for delivery confirmation
      cancelButtonText: 'Batal'
    }).then(result => {
      if (result.isConfirmed) {
        this._SuratJalanBateraiRest.deliver(id).subscribe({
          next: response => {
            Swal.fire('Success', 'Barang berhasil dikonfirmasi diterima!', 'success');
            this._suratJalanBateraiListComponent.callHookDirectly('init');
            this.closeModal(); // Close modal on success
          },
          error: err => {
            const errorMessage = err.response?.data?.message || 'Unknown error occurred';
            Swal.fire('Error', `Gagal mengkonfirmasi penerimaan: ${errorMessage}`, 'error');
          }
        });
      }
    });
  }

  createNewSjb() {
    this.addModal.openModal();
  }

  editDraft(surat) {
    this.draftModal.suratJalanBaterai = surat;
    this.draftModal.openModal(surat);
  }

  mapShippingType(type: string) {
    switch (type) {
      case 'request_pickup':
        return 'Request Pickup';
      case 'self_delivery':
        return 'Pengiriman Sendiri';
      case 'internal_courier':
        return 'Internal Kurir';
      case 'external_courier':
        return 'Eksternal Kurir';
      default:
        return type;
    }
  }

  // Untuk check apakah di ticket itu mempunyai surat dengan status on_delivery
  isAnyObjectOnDelivery(): boolean {
    return this.sjbDetail.some(item => item.status === 'on_delivery');
  }
}
